import { Injectable } from '@angular/core';
import { DeepLinksService } from '@shared/modules/deeplinks/common/deeplinks.service';

@Injectable()
export class DeepLinksServiceWeb extends DeepLinksService {
  protected redirectToDefaultView(): void {
    this._router.navigate(['/']);
  }

  protected onCheckForUpdates(_searchParams: URLSearchParams): void {
    throw new Error('Method not implemented.');
  }

  protected onChangeAccount(_searchParams: URLSearchParams): void {
    throw new Error('Method not implemented.');
  }
}
